
// import logo from '../logo.png'
import React from 'react';
import logo from '../logo.png'
import sidenav from '../assets/images/sidenav.png';
import { useState, useEffect } from "react"
import clsx from 'clsx'
import { Link } from 'react-router-dom';


const Navigation = () => {  

    // for top section fixed navbar

    const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) { 
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);




//   for menu code 

     // set a variable 'responsive' to false. Update it using 'setResponsive'
     const [responsive, setResponsive] = useState(false);

     const toggleResponsive = () => {
         //take current value of responsive and flip it
         setResponsive(prev => !prev);
     }

     const closeResponsive = () => {
        setResponsive(false); // Close the responsive menu
    }
    
    return (
        <>
    <div className={`menu ${isFixed ? 'fixed' : ''}`}>
    <section className='p-0 headbshd' id="section1">
    
                    <div className="section topmenu">
                        <div className="logo"><a href="/"> <img className="logoimg" src={logo} alt="logo" /></a></div>
                        <div className="menuNav">
                            {/* <div className="topnav" id="rTopnav"> */}
                            <div className={clsx('topnav', { 'responsive': responsive })}>
                                <div className="mobileWrap">  
                                  <ul>
                                    {/* <li><Link to="/" onClick={closeResponsive}>Home </Link></li> */}
                                      <li className='has_submenu'>
                                        <Link to="/about" onClick={closeResponsive}>About us </Link>
                                        <ul className="sub-menu">
                                            <li><Link to="/whoweare" onClick={closeResponsive}>Who We are </Link></li>
                                            <li><Link to="/approach" onClick={closeResponsive}>Our Approach</Link></li>
                                            <li><Link to="/weserve" onClick={closeResponsive}>Industries we serve</Link></li>                                          
                                        </ul>
                                      </li>

                                      <li className='has_submenu'>
                                        <Link onClick={closeResponsive}>Web </Link>
                                        <ul className="sub-menu">                                           
                                            <li><Link to="/web" onClick={closeResponsive}>Web </Link></li>
                                        </ul>  
                                      </li>

                                      
                                      <li className='has_submenu'>
                                        <Link onClick={closeResponsive}>Digital Marketing </Link>
                                        <ul className="sub-menu">                                            
                                            <li><Link to="/Seo" onClick={closeResponsive}>SEO </Link></li>
                                        </ul>  
                                      </li>                                     

                                      <li className='has_submenu'>
                                        <Link onClick={closeResponsive}>Videos </Link>
                                        <ul className="sub-menu">
                                        <li><Link to="/AnimatedVideo" onClick={closeResponsive}> Animated Explainer Video </Link></li>
                                        <li><Link to="/ProductVideo" onClick={closeResponsive}>Product Explainer Video </Link></li>
                                        </ul> 
                                      </li>

                                      <li className='has_submenu'>
                                        <Link onClick={closeResponsive}>Our Work </Link>
                                        <ul className="sub-menu">
                                            <li><Link to="/Website" onClick={closeResponsive}>Website </Link></li>
                                        </ul>  
                                      </li>

                                      <li className='has_submenu'>
                                        <Link onClick={closeResponsive}>Industries </Link>
                                        <ul className="sub-menu">
                                            {/* <li><Link to="/Education" onClick={closeResponsive}>Education</Link></li> */}
                                            <li><Link to="/indusries" onClick={closeResponsive}>Industries</Link></li>
                                        </ul>  
                                      </li>  

                                      <li><Link to="/contact" onClick={closeResponsive}>Contact Us </Link></li>
                                      <li className='mobbar'><Link className='icon' onClick={toggleResponsive}> 
                                          <img src={sidenav} alt="bar" />
                                          </Link> </li>
                                  </ul>
                                </div>
                            </div>
                        </div>

                        <div className="sidenav">
                            {/* <a href="#link">
                                <img src={sidenav} className="" alt="sideimg" />
                            </a> */}
                        </div>
                    </div>
                  
                </section>
                </div>


        </>
    )
}

export default Navigation;


